<ul class="step-timeline u-tablet">
  <li
    *ngFor="let status of groupedStatuses"
    class="step-timeline__item">
    <div
      id="step-item-1"
      class="step-timeline__button active"
      [class.active]="isActive(status)"></div>
    <div
      class="step-timeline__title"
      [class.current]="isCurrent(status)">
      {{ status.title | translate }}
    </div>
  </li>
</ul>
<div class="u-mobile">
  <span>{{ currentStatus?.title | translate }}</span>
</div>
